import { findNodeId } from "../../helpers/findNodeId";

export function handleUserPriceCreated(state, patch) {

    const {type, payload} = patch

    const nodeId = findNodeId(state, payload.qdId);

    if (!nodeId) {
        return state;
    }

    const q = state.quantitiesById[nodeId];

    if (!q) {
        return state;
    }

    const side =
        payload.priceType === 1 ? "buy" : "sell";

    return {
        ...state,
        lastGoldPriceCreationDate:payload.persianTimestamp,
        quantitiesById: {
            ...state.quantitiesById,
            [nodeId]: {
                ...q,
                prices: {
                    ...q.prices,
                    [side]: {
                        ...q.prices[side],
                        price: payload.price,
                    },
                },
            },
        },
    };
}